import React from 'react';
import PropTypes from 'prop-types';

const PlacesSuggestions = ({ loading, suggestions, getSuggestionItemProps }) => {
  if (loading || !suggestions.length) {
    return null;
  }

  return (
    <div
      css={() => ({
        position: 'relative',
        zIndex: 10,
      })}
    >
      <ul
        css={theme => ({
          borderRadius: theme.radii['radius-2'],
          boxShadow: `${theme.borderShadows[0]}, ${theme.shadows[3]}`,
          listStyle: 'none',
          marginTop: theme.space[1],
          padding: theme.space[0],
          position: 'absolute',
          width: '100%',
        })}
      >
        {suggestions.map(suggestion => (
          <li
            {...getSuggestionItemProps(suggestion)}
            css={theme => ({
              backgroundColor: suggestion.active
                ? theme.inputStyles.autocomplete.optionSelected.background
                : theme.inputStyles.background,
              color: suggestion.active
                ? theme.inputStyles.autocomplete.optionSelected.color
                : theme.inputStyles.color,
              borderBottom: `1px solid ${theme.inputStyles.border}`,
              cursor: 'default',
              fontSize: theme.fontSizes['text-s'],
              padding: `${theme.space[1]} ${theme.space[2]}`,
              ':first-of-type': {
                borderRadius: `${theme.radii['radius-2']} ${theme.radii['radius-2']} 0 0`,
              },
              ':last-of-type': {
                border: 0,
                borderRadius: `0 0 ${theme.radii['radius-2']} ${theme.radii['radius-2']}`,
              },
            })}
          >
            <span>{suggestion.description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

PlacesSuggestions.propTypes = {
  loading: PropTypes.bool,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
    })
  ),
  getSuggestionItemProps: PropTypes.func,
};

export default PlacesSuggestions;
